// extracted by mini-css-extract-plugin
export default {"arrow":"BUSelectore_arrow__idCx-","open":"BUSelectore_open__13-EB","close":"BUSelectore_close__bkALw"};